export type Species = 'dog' | 'cat' | 'rabbit' | 'bird' | 'reptile' | 'small_mammal' | 'other'
export type Sex = 'male' | 'female' | 'unknown'

export const SPECIES_LABELS: Record<Species, string> = {
  dog: 'Dog',
  cat: 'Cat',
  rabbit: 'Rabbit',
  bird: 'Bird',
  reptile: 'Reptile',
  small_mammal: 'Small Mammal',
  other: 'Other',
}

export const SEX_LABELS: Record<Sex, string> = {
  male: 'Male',
  female: 'Female',
  unknown: 'Unknown',
}

export interface PatientOwner {
  id: number
  client_id: number
  first_name: string
  last_name: string
  relationship: 'owner' | 'co_owner' | 'guardian' | 'foster' | 'rescue_org'
  is_primary: boolean
  status: 'active' | 'pending_transfer' | 'transferred'
}

export interface PatientListItem {
  id: number
  name: string
  species: Species
  breed: string | null
  sex: Sex
  is_desexed: boolean | null
  weight_kg: number | null
  color: string | null
  is_active: boolean
  primary_owner_id: number | null
  primary_owner_name: string | null
}

export interface Patient {
  id: number
  name: string
  species: Species
  breed: string | null
  date_of_birth: string | null
  sex: Sex
  is_desexed: boolean | null
  weight_kg: number | null
  color: string | null
  microchip_number: string | null
  is_active: boolean
  notes: string | null
  allergies: string | null
  photo_url: string | null
  created_at: string
  updated_at: string
  owners: PatientOwner[]
}

export interface PatientCreate {
  owner_client_id: number
  name: string
  species: Species
  sex: Sex
  breed?: string
  date_of_birth?: string
  is_desexed?: boolean | null
  weight_kg?: number | null
  color?: string
  microchip_number?: string
  notes?: string
  allergies?: string
}

export type PatientUpdate = Partial<Omit<PatientCreate, 'owner_client_id'>>

export interface PatientListResponse {
  items: PatientListItem[]
  total: number
}
